module.exports = __webpack_public_path__ + "static/img/libao.8253f344.png";